import config from '@config'

const { jwplayer: jwplayerConfig } = config

export const getPlaylistUrl = (
  videoId: string
): string | Record<string, unknown> => {
  if (videoId && videoId.length > 0) {
    return `${jwplayerConfig.baseUrl.media}${videoId}`
  }

  return `${jwplayerConfig.baseUrl.media}`
}
